module.exports = __webpack_public_path__ + "static/media/joelhoqp.a6dcca73.webp";